namespace Areas.Budget.GoTo {
    "use strict";

    export function goToActions(id: number) {
        return (e: any) => {
            if (e.value == 1) {
                goTo506Summary(id);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goTo506Detail(id);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 3) {
                goTo506SummaryFiltered(id);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 4) {
                goTo506DetailFiltered(id);
                clearSelectBoxSelection(e);
                return;
            }

        }
    }

    export function goTo506Summary(id) {

        if (id != null) {
            const url = `/Reports/Report/Get506Summary/${id}`;
            window.open(url);
        }

    }


    export function goTo506Detail(id) {

        if (id != null) {
            const url = `/Reports/Report/Get506Detail/${id}`;
            window.open(url);
        }

    }

    export function goTo506SummaryFiltered(id) {

        if (id != null) {
            const url = `/Reports/Report/Get506SummaryFiltered/${id}`;
            window.open(url);
        }

    }


    export function goTo506DetailFiltered(id) {

        if (id != null) {
            const url = `/Reports/Report/Get506DetailFiltered/${id}`;
            window.open(url);
        }

    }

}
